import { z } from 'zod';

import { initMaxCharacterLimitMessageGetter } from '@/common/helpers/validation';
import { BookingDayTimePart } from '@/em-api-client-typescript-fetch';
import type { TFunction } from '@/i18n';

export const createAdditionalInfoFormValidationSchema = (
  commonTranslation: TFunction<'common'>
) => {
  const getMaxCharacterLimitMessage =
    initMaxCharacterLimitMessageGetter(commonTranslation);

  return z.object({
    checkInTime: z
      .nativeEnum(BookingDayTimePart)
      .or(z.enum(['']))
      .optional(),
    checkOutTime: z
      .nativeEnum(BookingDayTimePart)
      .or(z.enum(['']))
      .optional(),
    specialRequests: z
      .string()
      .max(79, { message: getMaxCharacterLimitMessage(80) }),
    childBed: z.string().array(),
    childCot: z.string().array(),
    accessRequirements: z.string().array(),
  });
};

export type AdditionalInfoFormFields = z.infer<
  ReturnType<typeof createAdditionalInfoFormValidationSchema>
>;
